export const constructEntryClinic = (validData) => ({
    clinic_name: validData.clinic_name,
    clinic_branch: validData.clinic_branch,
    clinic_address: validData.clinic_address,
    telp_number: validData.clinic_telp,
    detailClinicInput: validData.clinic_email?.map((email) =>
    ({
        cabang: "null",
        clinic_email: email
    })
    )
})